<template>
  <div class="content">
    <!-- 皮卡丘！ -->
  </div>
</template>

<script>

export default {
  name: "hover-box",
  data () {
    return {

    };
  },
  created () {

  },
  methods: {

  }
};
</script>


<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/components/home/query/components/content-03.vue